import { BulkAssignmentOperation } from '@/api/apis/case';

export type BulkAssignmentResult = {
  operation: BulkAssignmentOperation;
  success: boolean;
  isPrimaryEvaluated: boolean;
  errorMessage: string | null;
};

export enum WsBulkAssignmentScenario {
  StateChanged = 'StateChanged',
  Completed = 'Completed',
}

export type WsBulkAssignmentMessageContent = {
  eventType: 'BulkOperationStatus';
  scenario: WsBulkAssignmentScenario;
  correlationId: string;
  initiatedByUserId: string;
  /** JSON-encoded `BulkAssignmentResult[]` */
  results: string;
  /** JSON-encoded `BulkEmployeeData[]`. */
  relatedEmployees: string;
};

export enum BulkAssignmentSubscriptionEvent {
  SubscribeOnBulkOperationNotifications = 'SubscribeOnBulkOperationNotifications',
  UnsubscribeFromBulkOperationNotifications = 'UnsubscribeFromBulkOperationNotifications',
}
